// TerrassenPost Theme JS
(function(){
var sels=[].slice.call(document.querySelectorAll('.opt-sel'));
function fmt(c){return (c/100).toLocaleString('de-DE',{minimumFractionDigits:0,maximumFractionDigits:2})+' \u20ac'}
function fmtE(e){return e.toLocaleString('de-DE')+' \u20ac'}
function curVariant(){
 if(!window.TP_VARIANTS)return null;
 var vals=sels.map(function(s){return s.value});
 return window.TP_VARIANTS.find(function(x){return vals.every(function(val,i){return x['option'+(i+1)]===val})})||null;
}
function upd(){
 var v=curVariant(); if(!v)return;
 document.getElementById('vid').value=v.id;
 var pr=document.getElementById('pr'),cpr=document.getElementById('cpr');
 if(pr)pr.textContent=fmt(v.price);
 if(cpr)cpr.textContent=(v.compare_at_price&&v.compare_at_price>v.price)?fmt(v.compare_at_price):'';
 calcMontage();
 renderSummary();
}
sels.forEach(function(s){s.addEventListener('change',upd)});

/* Zweite Preisanzeige zwischen Maßauswahl und den weiteren Schritten */
var midBox=null;
(function(){
 var form=document.getElementById('buyform'); if(!form)return;
 var firstAcc=form.querySelector('.opt-acc'); if(!firstAcc)return;
 midBox=document.createElement('div');
 midBox.id='pr-mid';
 midBox.style.cssText='background:#fff;border:1px solid #E8EAED;border-radius:10px;padding:14px 18px;margin:12px 0;box-shadow:0 2px 10px rgba(30,32,35,.05);display:flex;align-items:baseline;gap:10px;flex-wrap:wrap';
 form.insertBefore(midBox,firstAcc);
})();
function renderMid(){
 if(!midBox)return;
 var v=curVariant(); if(!v)return;
 var size=[];
 document.querySelectorAll('.opt-vals[data-name]').forEach(function(w){
  var b=w.querySelector('.opt-btn.sel'); if(b)size.push(b.getAttribute('data-val'));
 });
 var cmp=(v.compare_at_price&&v.compare_at_price>v.price)?'<s style="color:#7C818A;font-size:15px">'+fmt(v.compare_at_price)+'</s>':'';
 midBox.innerHTML='<span style="font-family:Poppins,sans-serif;font-weight:600;font-size:13px;color:#7C818A">'+(size.length?size.join(' \u00d7 '):'Deine Ma\u00dfe')+'</span><b style="font-family:Poppins,sans-serif;font-size:26px;color:#BF0C12;margin-left:auto">'+fmt(v.price)+'</b>'+cmp+'<small style="width:100%;font-size:12px;color:#7C818A">inkl. MwSt., zzgl. Versand</small>';
}

(function(){
 var gal=document.getElementById('gal'), main=document.getElementById('main-img');
 if(!gal||!main)return;
 var imgs=(gal.getAttribute('data-images')||'').split('|').filter(Boolean);
 if(imgs.length<2)return;
 var dotsWrap=document.getElementById('gal-dots');
 var idx=0, dots=[];
 function show(i){
  idx=(i+imgs.length)%imgs.length;
  main.src=imgs[idx];
  dots.forEach(function(d,j){d.classList.toggle('on',j===idx)});
 }
 if(dotsWrap){
  imgs.forEach(function(_,j){
   var d=document.createElement('span');
   d.className='gal-dot'+(j===0?' on':'');
   d.setAttribute('role','button');
   d.setAttribute('aria-label','Bild '+(j+1));
   d.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();show(j)});
   dotsWrap.appendChild(d); dots.push(d);
  });
 }
 var x0=null;
 gal.addEventListener('touchstart',function(e){x0=e.touches[0].clientX},{passive:true});
 gal.addEventListener('touchend',function(e){if(x0===null)return;var dx=e.changedTouches[0].clientX-x0;if(Math.abs(dx)>40)show(idx+(dx<0?1:-1));x0=null},{passive:true});
 show(0);
})();

var zones={z1:['32','40','41','42','43','44','45','46','47','48','50','51','52','53','57','58','59'],z2:['26','27','28','29','30','31','33','34','35','37','38','49','54','55','56','60','61','62','65'],z3:['20','21','36','39','63','64','66','67','68','69','97','98','99']};
var rateSteg=[67,82.5,97,112], rateGlas=[97,112,127,142];
var AT_FAKTOR=1.35;
var VERSAND={'Deutschland':49.9,'\u00d6sterreich':149.9};
function zoneOf(p2){if(zones.z1.indexOf(p2)>=0)return 1;if(zones.z2.indexOf(p2)>=0)return 2;if(zones.z3.indexOf(p2)>=0)return 3;var n=parseInt(p2,10);if(n>=1&&n<=25||n>=70&&n<=96)return 4;return 0}
/* Liefer-Zonen Nord/Süd (Grenzlinie Köln–Kassel–südlich Leipzig) – 5-stellige PLZ-Bereiche */
var TP_NS=[[1000,2999,'S'],[3000,3999,'N'],[4000,4099,'S'],[4100,4199,'N'],[4200,4239,'N'],[4240,4299,'S'],[4300,4399,'N'],[4400,4419,'S'],[4420,4439,'N'],[4440,4449,'S'],[4450,4459,'N'],[4460,4499,'S'],[4500,4519,'N'],[4520,5999,'S'],[6000,6599,'N'],[6600,6699,'S'],[6700,6999,'N'],[7000,9999,'S'],[10000,33999,'N'],[34000,34199,'N'],[34200,34313,'S'],[34314,34999,'N'],[35000,36999,'S'],[37000,51999,'N'],[52000,57999,'S'],[58000,59999,'N'],[60000,99999,'S']];
/* Zone aus PLZ-Präfix (ab 2 Ziffern). Rückgabe: 'N', 'S', 'X' (mehrdeutig – mehr Ziffern nötig) oder null */
function nsZoneP(prefix){
 var p=String(prefix||'').replace(/\D/g,'');
 if(p.length<2)return null;
 if(p.length>5)p=p.slice(0,5);
 var mul=Math.pow(10,5-p.length);
 var lo=parseInt(p,10)*mul, hi=lo+mul-1;
 if(hi<1000)return null;
 var zone=null;
 for(var i=0;i<TP_NS.length;i++){
  var r=TP_NS[i];
  if(r[1]<lo||r[0]>hi)continue;
  if(zone===null)zone=r[2];
  else if(zone!==r[2])return 'X';
 }
 return zone;
}
var lfPlzVal='';
function meters(s){if(!s)return 0;s=String(s).replace(',','.');var m=String(s).match(/([\d.]+)\s*Meter/i);if(m)return parseFloat(m[1]);var mm=String(s).match(/(\d{3,5})\s*mm/i);if(mm)return parseInt(mm[1],10)/1000;return 0}
function areaM2(){var a=1,b=1,got=0;sels.forEach(function(s){var v=meters(s.value);if(v>0){if(got===0){a=v;got=1}else if(got===1){b=v;got=2}}});if(got===0)return 0;if(got===1)return a;return a*b}
var montage=document.getElementById('montage'), plzIn=document.getElementById('plz-in'), mout=document.getElementById('montage-preis');
var landEl=document.getElementById('mt-land'), lfEl=document.getElementById('lf-land');
function landAT(){return lieferland()==='\u00d6sterreich'}
function lieferland(){return (lfEl&&lfEl.value)||(landEl&&landEl.value)||'Deutschland'}
function versandkosten(){return VERSAND[lieferland()]||VERSAND['Deutschland']}
function setLand(land){
 if(landEl)landEl.value=land;
 if(lfEl)lfEl.value=land;
 [].slice.call(document.querySelectorAll('.mt-land')).forEach(function(b){
  b.classList.toggle('sel',b.getAttribute('data-land')===land);
 });
 var lock=withMontage();
 [].slice.call(document.querySelectorAll('.lf-land')).forEach(function(b){
  var on=b.getAttribute('data-land')===land;
  b.classList.toggle('sel',on);
  b.style.display=(lock&&!on)?'none':'';
 });
 var lfl=document.getElementById('lf-label');
 if(lfl)lfl.textContent=lock?'Lieferung erfolgt gemeinsam mit der Montage:':'Wohin soll geliefert werden?';
 var pw=document.getElementById('plz-wrap');
 if(pw)pw.style.display=(land==='\u00d6sterreich')?'none':'';
 var lc=document.getElementById('lf-cost');
 if(lc)lc.innerHTML='Lieferung nach '+land+' \u00b7 Versandkosten: <b style="color:#BF0C12">'+versandkosten().toLocaleString('de-DE',{minimumFractionDigits:2})+' \u20ac</b>';
 updLfPlzVis();
}
var montageBetrag=0;
function calcMontage(){
 if(!mout)return;
 montageBetrag=0;
 if(landAT()){
  var rateA=(window.TP_GLAS?rateGlas:rateSteg)[3]*AT_FAKTOR;
  var areaA=areaM2(); if(areaA<=0)areaA=1;
  montageBetrag=Math.round(rateA*areaA);
  mout.innerHTML='Montagepreis \u00d6sterreich: <b style="color:#BF0C12;font-size:22px;font-family:Poppins,sans-serif">'+fmtE(montageBetrag)+'</b>';
  return;
 }
 var p2=(plzIn&&plzIn.value||'').replace(/\D/g,'').slice(0,2);
 if(p2.length<2){mout.innerHTML='<span style="color:#7C818A">Gib die ersten 2 Stellen deiner PLZ ein, um den Montagepreis zu sehen.</span>';return}
 var z=zoneOf(p2);
 if(!z){mout.innerHTML='<span style="color:#BF0C12">PLZ-Gebiet au\u00dferhalb unseres Montagegebiets \u2013 bitte kontaktiere uns.</span>';return}
 var rate=(window.TP_GLAS?rateGlas:rateSteg)[z-1];
 var area=areaM2(); if(area<=0)area=1;
 montageBetrag=Math.round(rate*area);
 mout.innerHTML='Montagepreis: <b style="color:#BF0C12;font-size:22px;font-family:Poppins,sans-serif">'+fmtE(montageBetrag)+'</b>';
}
if(montage){montage.addEventListener('change',function(){setLand(lieferland());calcMontage();onModeChange();renderSummary()});}
if(plzIn){plzIn.addEventListener('input',function(){calcMontage();renderSummary()});}
document.addEventListener('click',function(e){
 var b=e.target.closest('.mt-land, .lf-land'); if(!b)return;
 setLand(b.getAttribute('data-land'));
 calcMontage();onModeChange();renderSummary();
});

var autoAssigned=false;
function renderSummary(){
 renderMid();
 var box=document.getElementById('sum-box');
 var v=curVariant();
 var rows=[];
 document.querySelectorAll('.opt-vals[data-name]').forEach(function(w){
  var sel=w.querySelector('.opt-btn.sel');
  if(sel)rows.push([w.getAttribute('data-name'),sel.getAttribute('data-val')]);
 });
 if(v)rows.push(['Produktpreis',fmtE(Math.round(v.price/100))]);
 var zsOn=document.getElementById('zuschnitt-on');
 if(zsOn&&zsOn.checked){
  rows.push(['Wunschma\u00df',document.getElementById('zs-b-val').value+' \u00d7 '+document.getElementById('zs-t-val').value+' \u00b7 H\u00f6he '+document.getElementById('zs-h-val').value]);
 }
 var ledLabel=document.getElementById('led-label'), ledPrice=parseInt((document.getElementById('led-price')||{}).value,10)||0;
 if(ledLabel)rows.push(['Beleuchtung',ledLabel.value+(ledPrice>0?' (+'+fmtE(ledPrice)+')':'')]);
 if(montage&&montage.checked)rows.push(['Montage'+(landAT()?' (\u00d6sterreich)':''),montageBetrag>0?fmtE(montageBetrag):'PLZ eingeben']);
 if(!withMontage()&&!landAT()){
  var zz=nsZoneP(lfPlzVal);
  if(zz==='N'||zz==='S')rows.push(['Liefergebiet',(zz==='N'?'Nord (Lieferung dienstags)':'S\u00fcd (Lieferung donnerstags)')]);
 }
 var df=document.getElementById('datefield');
 if(df){
  var dLabel=(montage&&montage.checked)?'Liefer- & Montagetermin':'Liefertermin';
  var dVal;
  if(df.value){dVal=df.value.split('-').reverse().join('.')+(autoAssigned?' <small style="font-weight:600;color:#7C818A">(automatisch)</small>':'')}
  else if(deLieferung()&&!zoneOk()){dVal='\u2013 erst PLZ eingeben \u2013'}
  else{var nf=calNextFree?calNextFree():null;dVal=nf?'wird automatisch zugewiesen: '+nf.split('-').reverse().join('.'):'\u2013 bitte w\u00e4hlen \u2013'}
  rows.push([dLabel,dVal]);
 }
 var vk=versandkosten();
 rows.push(['Versand '+lieferland(),vk.toLocaleString('de-DE',{minimumFractionDigits:2})+' \u20ac']);
 var total=0;
 if(v)total=v.price/100;
 total+=ledPrice+((montage&&montage.checked)?montageBetrag:0)+vk;
 if(box){
  var html='<div style="font-family:Poppins,sans-serif;font-weight:700;font-size:13px;color:#7C818A;text-transform:uppercase;letter-spacing:.5px;margin-bottom:6px">Deine Auswahl</div>';
  rows.forEach(function(r){html+='<div class="sum-row"><span>'+r[0]+'</span><b>'+r[1]+'</b></div>'});
  if(v)html+='<div class="sum-row sum-total"><span>Gesamt</span><b>'+total.toLocaleString('de-DE',{minimumFractionDigits:2})+' \u20ac <small style="font-weight:600;color:#7C818A">inkl. Versand</small></b></div>';
  box.innerHTML=html;
 }
 var kr=document.getElementById('klarna-rate');
 if(kr&&total>0){var rate=Math.ceil(total/36);kr.innerHTML='Klarna Ratenzahlung ab <b>'+fmtE(rate)+' / Monat</b> (36 Monate)';}
}
document.addEventListener('tp:update',renderSummary);
document.addEventListener('change',function(e){if(e.target&&(e.target.id==='zuschnitt-on'))renderSummary()});
document.addEventListener('input',function(e){if(e.target&&e.target.type==='range')renderSummary()});
document.addEventListener('click',function(e){if(e.target.closest('.opt-vals .opt-btn'))setTimeout(renderSummary,0)});

/* Terminkalender – nur auf Terrassenüberdachungs- und Wintergarten-Seiten vorhanden (is_dach) */
var cal=document.getElementById('cal');
var calRender=null, calNextFree=null, calAssign=null;
var lfPlzWrap=null;
function withMontage(){return !!(montage&&montage.checked)}
function atLieferung(){return landAT()&&!withMontage()}
function deLieferung(){return !landAT()&&!withMontage()}
function zoneOk(){var z=nsZoneP(lfPlzVal);return z==='N'||z==='S'}
var AT_ANKER=new Date(2026,0,3);
function atWoche(d){
 var diff=Math.round((new Date(d.getFullYear(),d.getMonth(),d.getDate())-AT_ANKER)/86400000);
 return Math.floor(diff/7)%2===0;
}
function calDays(){
 if(withMontage())return [3,5];
 if(atLieferung())return [6];
 var z=nsZoneP(lfPlzVal);
 if(z==='N')return [2];
 if(z==='S')return [4];
 return []; /* Lieferung DE ohne gültige PLZ: keine Tage wählbar */
}
function calCap(){return withMontage()?1:5}
function updLfPlzVis(){
 if(!lfPlzWrap)return;
 lfPlzWrap.style.display=deLieferung()?'':'none';
}
if(cal){
 var booked={};try{booked=JSON.parse(cal.getAttribute('data-booked')||'{}')||{}}catch(e){}
 (cal.getAttribute('data-booked-dates')||'').split(',').forEach(function(s){
  var d=s.trim(); if(!d)return;
  var cur=booked[d];
  if(cur&&typeof cur==='object'){cur.t=(cur.t||0)+1}
  else{booked[d]={t:(typeof cur==='number'?cur:0)+1}}
 });
 /* PLZ-Feld für Lieferung Deutschland (Nord = Di, Süd = Do) – ab 2 Ziffern, Grenzgebiete brauchen mehr */
 lfPlzWrap=document.createElement('div');
 lfPlzWrap.id='lf-plz-wrap';
 lfPlzWrap.style.cssText='margin:0 0 14px';
 lfPlzWrap.innerHTML='<label for="lf-plz" style="display:block;font-size:14px;color:#24262A;margin:0 0 8px">Deine PLZ f\u00fcr den Liefertag:</label><input id="lf-plz" type="text" inputmode="numeric" maxlength="5" placeholder="PLZ" style="width:140px;height:42px;padding:0 14px;border:1.5px solid #D8DBDF;border-radius:8px;font-family:Poppins,sans-serif;font-weight:600;font-size:15px;display:block"><div id="lf-plz-out" style="margin-top:8px;font-size:13.5px"><span style="color:#7C818A">Gib mindestens die ersten 2 Ziffern deiner PLZ ein, um deinen Liefertag zu sehen.</span></div>';
 cal.parentNode.insertBefore(lfPlzWrap,cal);
 var lfPlzIn=lfPlzWrap.querySelector('#lf-plz'), lfPlzOut=lfPlzWrap.querySelector('#lf-plz-out');
 lfPlzIn.addEventListener('input',function(){
  lfPlzVal=lfPlzIn.value.replace(/\D/g,'').slice(0,5);
  if(lfPlzIn.value!==lfPlzVal)lfPlzIn.value=lfPlzVal;
  var z=nsZoneP(lfPlzVal);
  if(z==='N'||z==='S'){
   lfPlzOut.innerHTML='<span style="color:#1F9D5B;font-weight:600">Zone '+(z==='N'?'Nord \u2013 Lieferung dienstags':'S\u00fcd \u2013 Lieferung donnerstags')+'</span>';
  }else if(z==='X'){
   lfPlzOut.innerHTML='<span style="color:#7C818A">Grenzgebiet \u2013 bitte gib noch '+(5-lfPlzVal.length>1?'ein paar':'die letzte')+' Ziffer'+(5-lfPlzVal.length>1?'n':'')+' deiner PLZ ein.</span>';
  }else if(lfPlzVal.length>=2){
   lfPlzOut.innerHTML='<span style="color:#BF0C12">PLZ nicht gefunden \u2013 bitte pr\u00fcfe deine Eingabe.</span>';
  }else{
   lfPlzOut.innerHTML='<span style="color:#7C818A">Gib mindestens die ersten 2 Ziffern deiner PLZ ein, um deinen Liefertag zu sehen.</span>';
  }
  if(calRender)calRender();
  renderSummary();
 });
 var sel=null, view=new Date(); view.setDate(1);
 var min=new Date(); min.setHours(0,0,0,0); min.setDate(min.getDate()+5);
 function iso(d){return d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0')}
 function bookedOf(d){
  var b=booked[iso(d)];
  if(b&&typeof b==='object')return (b.t!=null?b.t:Math.max(b.l||0,b.m||0));
  return b||0;
 }
 function isDay(d){
  var w=d.getDay();
  if(calDays().indexOf(w)<0)return false;
  if(atLieferung()&&!atWoche(d))return false;
  return true;
 }
 function allowed(d){if(d<min)return false;if(!isDay(d))return false;if(bookedOf(d)>=calCap())return false;return true}
 function render(){
  var m=['Januar','Februar','M\u00e4rz','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'];
  var hint='';
  if(deLieferung()&&!zoneOk())hint='<div style="font-size:12.5px;color:#BF0C12;margin-bottom:8px">Bitte gib zuerst deine PLZ ein \u2013 danach kannst du deinen Liefertermin w\u00e4hlen.</div>';
  var html=hint+'<div class="cal-hint" style="font-size:12.5px;color:#5B6068;margin-bottom:8px"></div>';
  html+='<div class="cal-head"><button type="button" data-nav="-1">\u2039</button><span>'+m[view.getMonth()]+' '+view.getFullYear()+'</span><button type="button" data-nav="1">\u203a</button></div><div class="cal-grid">';
  ['Mo','Di','Mi','Do','Fr','Sa','So'].forEach(function(d){html+='<span class="cal-dow">'+d+'</span>'});
  var first=new Date(view), start=(first.getDay()+6)%7;
  for(var i=0;i<start;i++)html+='<span></span>';
  var days=new Date(view.getFullYear(),view.getMonth()+1,0).getDate();
  for(var d=1;d<=days;d++){
   var dt=new Date(view.getFullYear(),view.getMonth(),d);
   var ok=allowed(dt), s=sel&&iso(dt)===sel;
   var rest=calCap()-bookedOf(dt);
   var full=isDay(dt)&&dt>=min&&rest<=0;
   var tip='';
   if(full)tip=' title="Ausgebucht"';
   else if(ok&&calCap()>1)tip=' title="noch '+rest+' von '+calCap()+' Pl\u00e4tzen frei"';
   html+='<span class="cal-d'+(ok?'':' off')+(s?' sel':'')+'" '+(ok?'data-d="'+iso(dt)+'"':'')+tip+'>'+d+'</span>';
  }
  cal.innerHTML=html+'</div>';
 }
 calNextFree=function(){
  if(deLieferung()&&!zoneOk())return null;
  var d=new Date(min);
  for(var i=0;i<400;i++){if(allowed(d))return iso(d);d.setDate(d.getDate()+1)}
  return null;
 };
 calAssign=function(){
  var nf=calNextFree(); if(!nf)return false;
  sel=nf; document.getElementById('datefield').value=nf;
  var p=nf.split('-'); view=new Date(+p[0],+p[1]-1,1);
  render();
  return true;
 };
 calRender=function(){
  if(sel){var p=sel.split('-'),sd=new Date(+p[0],+p[1]-1,+p[2]);if(!allowed(sd)){sel=null;var dfx=document.getElementById('datefield');if(dfx)dfx.value='';autoAssigned=false}}
  render();
 };
 cal.addEventListener('click',function(e){
  var t=e.target;
  if(t.hasAttribute('data-nav')){view.setMonth(view.getMonth()+parseInt(t.getAttribute('data-nav')));render();return}
  if(t.hasAttribute('data-d')){sel=t.getAttribute('data-d');autoAssigned=false;document.getElementById('datefield').value=sel;render();renderSummary()}
 });
 render();
 updLfPlzVis();
}
function onModeChange(){updLfPlzVis();if(calRender)calRender()}
renderSummary();

function collectProps(){
 var f=document.getElementById('buyform'); var out={};
 if(!f)return out;
 [].slice.call(f.querySelectorAll('[name^="properties["]')).forEach(function(el){
  if(el.disabled)return;
  if((el.type==='checkbox'||el.type==='radio')&&!el.checked)return;
  var m=el.name.match(/^properties\[(.+)\]$/); if(!m)return;
  var val=(el.value||'').trim(); if(!val)return;
  out[m[1]]=val;
 });
 if(!withMontage()){delete out['Montageservice'];delete out['PLZ-Gebiet'];delete out['Montageland']}
 if(withMontage()&&landAT())delete out['PLZ-Gebiet'];
 if(deLieferung()&&lfPlzVal.length>=2){
  var zz=nsZoneP(lfPlzVal);
  if(zz==='N'||zz==='S'){
   out['Liefer-PLZ']=lfPlzVal;
   out['Liefergebiet']=(zz==='N'?'Nord':'S\u00fcd');
  }
 }
 document.querySelectorAll('.opt-vals[data-name]').forEach(function(w){
  var b=w.querySelector('.opt-btn.sel'); if(!b)return;
  var n=w.getAttribute('data-name'); if(!n||out[n])return;
  out[n]=b.getAttribute('data-val');
 });
 return out;
}
function wunschmass(){
 var on=document.getElementById('zuschnitt-on');
 if(!on||!on.checked)return '';
 var b=document.getElementById('zs-b-val'),t=document.getElementById('zs-t-val'),h=document.getElementById('zs-h-val');
 if(!b||!t||!h)return '';
 return b.value+' \u00d7 '+t.value+' \u00b7 H\u00f6he '+h.value;
}
function addToCart(id,qty,props){
 return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:id,quantity:qty,properties:props||{}})});
}

var form=document.getElementById('buyform');
if(form)form.addEventListener('submit',function(e){
 e.preventDefault();
 var dfEl=document.getElementById('datefield');
 if(dfEl&&deLieferung()){
  var zSub=nsZoneP(lfPlzVal);
  if(zSub!=='N'&&zSub!=='S'){
   alert(zSub==='X'?'Deine PLZ liegt im Grenzgebiet \u2013 bitte gib die vollst\u00e4ndige PLZ ein (Punkt Wunschtermin).':'Bitte gib deine PLZ f\u00fcr die Lieferung ein (Punkt Wunschtermin), damit wir dir den richtigen Liefertag zuweisen k\u00f6nnen.');
   return;
  }
 }
 if(dfEl&&!dfEl.value&&calAssign){
  if(calAssign()){autoAssigned=true;renderSummary()}
 }
 if(dfEl&&!dfEl.value){alert(withMontage()?'Aktuell ist kein freier Liefer- & Montagetermin verf\u00fcgbar \u2013 bitte kontaktiere uns.':'Aktuell ist kein freier Liefertermin verf\u00fcgbar \u2013 bitte kontaktiere uns.');return}
 var needMontage=withMontage();
 if(needMontage&&!landAT()){
  var p2=(plzIn&&plzIn.value||'').replace(/\D/g,'').slice(0,2);
  if(p2.length<2||!zoneOf(p2)||montageBetrag<=0){alert('Bitte gib f\u00fcr den Montageservice die ersten 2 Stellen deiner PLZ ein (Punkt 3).');return}
 }
 var vidEl=document.getElementById('vid');
 var mainId=vidEl?parseInt(vidEl.value,10):0;
 if(!mainId)return;
 var termin=(dfEl&&dfEl.value)||'';
 var terminLabel=needMontage?'Liefer- & Montagetermin':'Liefertermin';
 var wm=wunschmass();
 var ledEl=document.getElementById('led-id');
 var ledId=ledEl?parseInt(ledEl.value,10)||0:0;
 var chain=addToCart(mainId,1,collectProps());
 if(ledId>0){
  var lprops={'Leistung':'LED-Beleuchtung','Ausf\u00fchrung':(document.getElementById('led-label')||{}).value||''};
  if(termin)lprops[terminLabel]=termin;
  chain=chain.then(function(){return addToCart(ledId,1,lprops)});
 }
 if(needMontage){
  var mprops={'Leistung':'Montageservice'};
  if(landAT()){mprops['Land']='\u00d6sterreich'}
  else{mprops['PLZ-Gebiet']=(plzIn&&plzIn.value||'').replace(/\D/g,'').slice(0,2)}
  if(wm)mprops['Wunschma\u00df']=wm;
  if(termin)mprops[terminLabel]=termin;
  chain=chain.then(function(){return addToCart(58826003415385,montageBetrag,mprops)});
 }
 chain.then(function(){window.location='/cart'}).catch(function(){window.location='/cart'});
});
})();